import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import { AllEventsFragmentFragment } from '../../../graphql/fragments/allEventsFragement.generated';
import { EventsMinimalQuery } from '../../../graphql/queries/eventsMinimal.generated';
import EventCard from './EventCard';
import i18n from '@/utils/i18n';
import { FaCreditCard, FaDownload, FaInfoCircle } from 'react-icons/fa';
import DownloadsModalWrapper from './DownloadsModalWrapper';
import { EventAccount } from '../../../graphql/generatedTypes';
import { Routes } from '@/utils/routes';

// Extract the minimal event type from the query result
type MinimalEvent = NonNullable<NonNullable<EventsMinimalQuery['events']>[0]>;

// Union type that accepts either minimal or full event data
export type EventData = AllEventsFragmentFragment | MinimalEvent;

const RenderEvent = ({
  eventItem,
  showSelect,
  showDeposit,
  history,
  showGoToDepositClearing,
  eventAccount,
  isSelected,
  setEventId,
}: {
  eventItem: EventData;
  showSelect: boolean;
  showDeposit: boolean;
  history: any;
  showGoToDepositClearing: boolean;
  eventAccount: EventAccount | undefined;
  isSelected: boolean;
  setEventId: ((eventId: string | null) => void) | undefined;
}) => {
  const [showDownloadsModal, setShowDownloadsModal] = useState(false);

  return (
    <div key={eventItem.id}>
      <EventCard event={eventItem}>
        <>
          {showSelect && !isSelected && (
            <Button
              className="mb-2 me-2"
              onClick={() => {
                if (setEventId) {
                  setEventId(eventItem.id);
                }
              }}
              color="primary"
            >
              {i18n.t('CreateOrderFulfillment:selectEvent')}
            </Button>
          )}

          {showSelect && isSelected && (
            <Button
              className="mb-2 me-2"
              onClick={() => {
                if (setEventId) {
                  setEventId(null);
                }
              }}
              color="primary"
            >
              {i18n.t('CreateOrderFulfillment:unSelectEvent')}
            </Button>
          )}

          {!showSelect && (
            <>
              <Link to={Routes.eventDetail(eventItem.id)}>
                <Button className="mb-2 me-2">
                  <FaInfoCircle /> {i18n.t('Events:showDetails')}
                </Button>
              </Link>

              <Button
                className="mb-2 me-2"
                onClick={() => {
                  setShowDownloadsModal(true);
                }}
                color="secondary"
              >
                <FaDownload /> {i18n.t('Common:downloads')}
              </Button>
            </>
          )}

          {showGoToDepositClearing && (
            <Link
              to={Routes.eventAccountDepositClearing(
                eventItem.id,
                eventAccount?.id,
              )}
            >
              <Button className="mb-2 me-2" color="secondary">
                <FaCreditCard /> {i18n.t('EventAccount:goToDepositClearing')}
              </Button>
            </Link>
          )}
        </>
      </EventCard>

      <DownloadsModalWrapper
        isOpen={showDownloadsModal}
        eventItem={eventItem}
        eventAccount={eventAccount}
        showDeposit={showDeposit}
        onClose={() => setShowDownloadsModal(false)}
      />
    </div>
  );
};

export type EventListProps = {
  events: EventData[];
  eventAccount?: EventAccount;
  showGoToDepositClearing?: boolean;
  showSelect?: boolean;
  showDeposit?: boolean;
  selectedEventId?: string | null;
  setEventId?: (eventId: string | null) => void; // linked to showSelect
};

export function EventList({
  events,
  eventAccount,
  showGoToDepositClearing = false,
  showSelect = false,
  showDeposit = false,
  selectedEventId = null,
  setEventId,
}: EventListProps) {
  const history = useHistory();

  return (
    <div className="d-flex flex-wrap gap-3">
      {events.map((eventItem) => (
        <RenderEvent
          key={eventItem.id}
          eventItem={eventItem}
          showSelect={showSelect}
          showDeposit={showDeposit}
          history={history}
          showGoToDepositClearing={showGoToDepositClearing}
          eventAccount={eventAccount}
          setEventId={setEventId}
          isSelected={eventItem.id === selectedEventId}
        />
      ))}
    </div>
  );
}
